import { render } from "./ArticleModal.vue?vue&type=template&id=8ebfbd46&scoped=true"
import script from "./ArticleModal.vue?vue&type=script&lang=js"
export * from "./ArticleModal.vue?vue&type=script&lang=js"

import "./ArticleModal.vue?vue&type=style&index=0&id=8ebfbd46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ebfbd46"]])

export default __exports__